module.exports = __webpack_public_path__ + "static/media/download.b8b410f1.png";